import * as ast from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validatePng(nodeFields, pifFileSummary, accept) {
    const { idField, richAssetField } = nodeFields;
    if (!richAssetField || !ast.isRichAssetPng(richAssetField?.content))
        return;
    const pngString = richAssetField?.content?.value?.trim() ?? '';
    // This could either be a static or dynamic png content based on the string format
    if (pngString.startsWith('{') && pngString.endsWith('}')) {
        const indexOfStar = pngString.indexOf('*');
        if (indexOfStar === -1) {
            accept('error', `The dynamic png content is not formatted correctly. It should be in the format '{ source_node * source_var }'.`, {
                node: richAssetField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: nodeFields.nodeNumber,
                    propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                },
            });
        }
        else {
            // Split the string into it's parts. Account for start and end parenthesis
            const nodeNumber = pngString.slice(1, indexOfStar).trim();
            const variableName = pngString
                .slice(indexOfStar + 1, pngString.length - 1)
                .trim();
            // The referenced node must exist
            const refNodeFields = pifFileSummary.getNodeByNodeNumber(nodeNumber);
            if (!refNodeFields) {
                accept('error', `Could not resolve reference to Node named '${nodeNumber}'.`, {
                    node: richAssetField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
            else {
                // The referenced node exists. Get the required fields for the referenced node.
                const { outputField: refOutputField } = refNodeFields;
                // The variable must exist on the referenced node
                const matchingOutputVariable = refOutputField?.output?.find((o) => {
                    return o.value === variableName;
                });
                if (!matchingOutputVariable) {
                    accept('error', `The referenced variable '${variableName}' does not exist on the referenced node '${refNodeFields.nodeNumber}'.`, {
                        node: richAssetField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: nodeFields.nodeNumber,
                            propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                        },
                    });
                }
            }
        }
    }
    else {
        // The provided url should start with https.
        if (!pngString || pngString.startsWith('https://') === false) {
            accept('error', `The static png content is not formatted correctly. URL should point to a secure (https) location.`, {
                node: richAssetField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: nodeFields.nodeNumber,
                    propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                },
            });
        }
    }
}
//# sourceMappingURL=png.js.map